/*
 * Global helpers that theme scripts call but no file defined (shrine.null.js is empty, and there is no global.js).
 * Without them media-gallery.js throws in its constructor and the product thumbnails do nothing.
 * Each helper is only defined if missing, so restoring a full core script later doesn't conflict.
 * Implementations follow Shopify's Dawn global.js (MIT).
 */
(function () {
  if (typeof window.debounce !== 'function') {
    window.debounce = function debounce(fn, wait) {
      let t;
      return function (...args) {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    };
  }

  if (typeof window.pauseAllMedia !== 'function') {
    window.pauseAllMedia = function pauseAllMedia() {
      document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow?.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow?.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    };
  }

  if (typeof window.getFocusableElements !== 'function') {
    window.getFocusableElements = function getFocusableElements(container) {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
  }

  const trapFocusHandlers = {};

  if (typeof window.trapFocus !== 'function') {
    window.trapFocus = function trapFocus(container, elementToFocus = container) {
      const elements = window.getFocusableElements(container);
      const first = elements[0];
      const last = elements[elements.length - 1];

      window.removeTrapFocus();

      trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;
        document.addEventListener('keydown', trapFocusHandlers.keydown);
      };

      trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
      };

      trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return;
        // On the last focusable element and tab forward: focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }
        // On the first focusable element (or the container) and tab backward: focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener('focusout', trapFocusHandlers.focusout);
      document.addEventListener('focusin', trapFocusHandlers.focusin);

      if (elementToFocus) elementToFocus.focus();

      if (
        elementToFocus &&
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    };
  }

  if (typeof window.removeTrapFocus !== 'function') {
    window.removeTrapFocus = function removeTrapFocus(elementToFocus = null) {
      document.removeEventListener('focusin', trapFocusHandlers.focusin);
      document.removeEventListener('focusout', trapFocusHandlers.focusout);
      document.removeEventListener('keydown', trapFocusHandlers.keydown);

      if (elementToFocus) elementToFocus.focus();
    };
  }

  if (typeof window.onKeyUpEscape !== 'function') {
    window.onKeyUpEscape = function onKeyUpEscape(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;

      const summaryElement = openDetailsElement.querySelector('summary');
      openDetailsElement.removeAttribute('open');
      summaryElement.setAttribute('aria-expanded', false);
      summaryElement.focus();
    };
  }
})();
